import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Crown, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PremiumLockedOverlayProps {
  onReactivate: () => void;
}

export const PremiumLockedOverlay = ({ onReactivate }: PremiumLockedOverlayProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const benefits = [
    t('preferences.premium.locked.benefit1'),
    t('preferences.premium.locked.benefit2'),
    t('preferences.premium.locked.benefit3'),
    t('preferences.premium.locked.benefit4')
  ];

  return (
    <div className="absolute inset-0 z-10 rounded-lg backdrop-blur-[1px] bg-background/60 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10">
          <Crown className="h-8 w-8 text-primary" />
        </div>
        
        <div className="space-y-2">
          <h3 className="text-2xl font-bold text-foreground">
            {t('preferences.premium.locked.title')}
          </h3>
          <p className="text-sm text-muted-foreground">
            {t('preferences.premium.locked.description')}
          </p>
        </div>

        <div className="bg-card/80 rounded-lg p-4 space-y-2">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start gap-2 text-left">
              <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
              <span className="text-sm text-foreground">{benefit}</span>
            </div>
          ))}
        </div>

        <Button 
          onClick={() => navigate('/checkout')} 
          size="lg"
          className="w-full h-12 sm:h-11"
        >
          {t('preferences.premium.locked.reactivateButton')}
        </Button>
      </div>
    </div>
  );
};